"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _integerPropType = _interopRequireDefault(require("@mui/utils/integerPropType"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _LinearProgress = _interopRequireDefault(require("../LinearProgress"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _slotShouldForwardProp = _interopRequireDefault(require("../styles/slotShouldForwardProp"));
var _mobileStepperClasses = require("./mobileStepperClasses");
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, position = ownerState.position;
    var slots = {
        root: [
            'root',
            "position".concat((0, _capitalize.default)(position))
        ],
        dots: [
            'dots'
        ],
        dot: [
            'dot'
        ],
        dotActive: [
            'dotActive'
        ],
        progress: [
            'progress'
        ]
    };
    return (0, _composeClasses.default)(slots, _mobileStepperClasses.getMobileStepperUtilityClass, classes);
};
var MobileStepperRoot = (0, _zeroStyled.styled)(_Paper.default, {
    name: 'MuiMobileStepper',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["position".concat((0, _capitalize.default)(ownerState.position))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: (theme.vars || theme).palette.background.default,
        padding: 8,
        variants: [
            {
                props: function(param) {
                    var position = param.position;
                    return position === 'top' || position === 'bottom';
                },
                style: {
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    zIndex: (theme.vars || theme).zIndex.mobileStepper
                }
            },
            {
                props: {
                    position: 'top'
                },
                style: {
                    top: 0
                }
            },
            {
                props: {
                    position: 'bottom'
                },
                style: {
                    bottom: 0
                }
            }
        ]
    };
}));
var MobileStepperDots = (0, _zeroStyled.styled)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dots',
    overridesResolver: function(props, styles) {
        return styles.dots;
    }
})({
    variants: [
        {
            props: {
                variant: 'dots'
            },
            style: {
                display: 'flex',
                flexDirection: 'row'
            }
        }
    ]
});
var MobileStepperDot = (0, _zeroStyled.styled)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dot',
    shouldForwardProp: function(prop) {
        return (0, _slotShouldForwardProp.default)(prop) && prop !== 'dotActive';
    },
    overridesResolver: function(props, styles) {
        var dotActive = props.dotActive;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        variants: [
            {
                props: {
                    variant: 'dots'
                },
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    backgroundColor: (theme.vars || theme).palette.action.disabled,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    margin: '0 2px'
                }
            },
            {
                props: {
                    variant: 'dots',
                    dotActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    };
}));
var MobileStepperProgress = (0, _zeroStyled.styled)(_LinearProgress.default, {
    name: 'MuiMobileStepper',
    slot: 'Progress',
    overridesResolver: function(props, styles) {
        return styles.progress;
    }
})({
    variants: [
        {
            props: {
                variant: 'progress'
            },
            style: {
                width: '50%'
            }
        }
    ]
});
var MobileStepper = /*#__PURE__*/ React.forwardRef(function MobileStepper(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMobileStepper'
    });
    var _props_activeStep = props.activeStep, activeStep = _props_activeStep === void 0 ? 0 : _props_activeStep, backButton = props.backButton, className = props.className, LinearProgressProps = props.LinearProgressProps, nextButton = props.nextButton, _props_position = props.position, position = _props_position === void 0 ? 'bottom' : _props_position, steps = props.steps, _props_variant = props.variant, variant = _props_variant === void 0 ? 'dots' : _props_variant, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, other = _object_without_properties(props, [
        "activeStep",
        "backButton",
        "className",
        "LinearProgressProps",
        "nextButton",
        "position",
        "steps",
        "variant",
        "slots",
        "slotProps"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        activeStep: activeStep,
        position: position,
        variant: variant
    });
    var value;
    if (variant === 'progress') {
        if (steps === 1) {
            value = 100;
        } else {
            value = Math.ceil(activeStep / (steps - 1) * 100);
        }
    }
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            progress: LinearProgressProps
        }, slotProps)
    };
    var _ref = _sliced_to_array((0, _useSlot.default)('root', {
        ref: ref,
        elementType: MobileStepperRoot,
        shouldForwardComponentProp: true,
        className: (0, _clsx.default)(classes.root, className),
        externalForwardedProps: _object_spread({}, externalForwardedProps, other),
        ownerState: ownerState,
        additionalProps: {
            square: true,
            elevation: 0
        }
    }), 2), RootSlot = _ref[0], rootSlotProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('dots', {
        className: classes.dots,
        elementType: MobileStepperDots,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), DotsSlot = _ref1[0], dotsSlotProps = _ref1[1];
    var _ref2 = _sliced_to_array((0, _useSlot.default)('dot', {
        elementType: MobileStepperDot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), DotSlot = _ref2[0], dotSlotProps = _ref2[1];
    var _ref3 = _sliced_to_array((0, _useSlot.default)('progress', {
        className: classes.progress,
        elementType: MobileStepperProgress,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            value: value,
            variant: 'determinate'
        }
    }), 2), ProgressSlot = _ref3[0], progressSlotProps = _ref3[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: [
            backButton,
            variant === 'text' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === 'dots' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(DotsSlot, _object_spread_props(_object_spread({}, dotsSlotProps), {
                children: _to_consumable_array(new Array(steps)).map(function(_, index) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DotSlot, _object_spread_props(_object_spread({}, dotSlotProps), {
                        className: (0, _clsx.default)(classes.dot, dotSlotProps.className, index === activeStep && classes.dotActive),
                        dotActive: index === activeStep
                    }), index);
                })
            })),
            variant === 'progress' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressSlot, _object_spread({}, progressSlotProps)),
            nextButton
        ]
    }));
});
process.env.NODE_ENV !== "production" ? MobileStepper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   * @default 0
   */ activeStep: _integerPropType.default,
    /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */ backButton: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * Props applied to the `LinearProgress` element.
   * @deprecated Use `slotProps.progress` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ LinearProgressProps: _propTypes.default.object,
    /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */ nextButton: _propTypes.default.node,
    /**
   * Set the positioning type.
   * @default 'bottom'
   */ position: _propTypes.default.oneOf([
        'bottom',
        'static',
        'top'
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        dot: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        dots: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        progress: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        dot: _propTypes.default.elementType,
        dots: _propTypes.default.elementType,
        progress: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    }),
    /**
   * The total steps.
   */ steps: _integerPropType.default.isRequired,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'dots'
   */ variant: _propTypes.default.oneOf([
        'dots',
        'progress',
        'text'
    ])
} : void 0;
var _default = exports.default = MobileStepper;
